@let gridData = $gridData();
@let T = resource.value()?.data!;

<unity-grid-shared
  gridTitle="Users"
  [gridData]="gridData"
  [gridError]="$gridError()"
  [gridLoading]="$gridLoading()"
  [defaultSort]="defaultSort"
  (dataQueryEvent)="onDataQuery($event)">
  <kendo-grid-column field="full_name" title="Name">
    <ng-template let-user kendoGridCellTemplate [unityTyped]="T">
      <unity-link-gridcell-shared [displayText]="user.full_name" [link]="['/user', user.id]" />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="user_name" title="Email">
    <ng-template let-user kendoGridCellTemplate [unityTyped]="T">
      <unity-link-mailto-shared [emailAddress]="user.user_name" />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="current_state.name" title="User Status">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      <unity-chip-workflow-state-shared [name]="item.current_state.name" [value]="item.current_state.enum_value" />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="role.agency_name" title="Business Partner" [filterable]="false">
    <ng-template let-user kendoGridCellTemplate [unityTyped]="T">
      <unity-link-gridcell-shared [displayText]="user.role.agency_name" [link]="['/business-partner', user.role.agency_id]" />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="role.name" title="Role" [filterable]="false" />
  <kendo-grid-column field="role.current_state_name" title="Role Status" [filterable]="false">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      <unity-chip-workflow-state-shared [name]="item.role.current_state_name" [value]="item.role.current_state_enum_value" />
    </ng-template>
  </kendo-grid-column>
</unity-grid-shared>
